'use strict';

var _    = require('underscore');
var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates a submenu button
 *
 * @class
 */

class TabSubNavButton extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'name': 'no name',
                'description': undefined,
                'icon': false,
                'class': "",
                'extraClass': ""
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class='editor__tab__subnav__button js-editor__tab__subnav__sortable float'>
                <a class='editor__tab__subnav__button__btn btn btn--m js-editor__tab__subnav__button__btn' title='<% if (description != undefined) { %><%-description%><% } else { %><%-name%><% } %>'>
                    <% if(icon) { %><div class='btn__icon'><%= embedded_svg(icon) %></div><% } %>
                    <div class='btn__txt'><%- name %></div>
                </a>
            </div>
        `;

        super.render();

        if(options.fields['class']) {
            $('.editor__tab__subnav__button__btn', this.$el).addClass(options.fields['class']);
        }

        if(options.fields['extraClass']) {
            $('.editor__tab__subnav__button__btn', this.$el).addClass(options.fields['extraClass']);
        }

        /**
         * Click event
         *
         * @fires SubNavbutton#_clicked
         */

         $('.js-editor__tab__subnav__button__btn', this.$el).on('click', this._clicked);
    }

    /**
     * @event SubNavbutton#Cioui:SubNavbutton:clicked
     * @property {String}Cioui:SubNavbutton:clicked
     * @returns {Object} event - native click Event
     */

    _clicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:SubNavButton:clicked', e);
    }

    /**
     * Update name of the button
     * @param {string} name Updated name of the button
     */
    updateName(name) {
        $('.btn__txt', this.$el).text(name);
    }

    /**
     * Update title of the button
     * @param {string} title Updated title of the button
     */
    updateTitle(title) {
        $('.editor__tab__subnav__button__btn', this.$el).attr('title', title);
    }
}

module.exports = TabSubNavButton;
